import { AnyAri } from '@atlassian/ari';

import { type Panel } from '../types';

export const doPreviewPanelTypesMatch = (currPanel: Panel | null, nextPanel: Panel) => {
	// if both panels have their types set, we will check if they match
	if (currPanel?.type && nextPanel?.type) {
		return currPanel.type === nextPanel.type;
	}
	// else check against both panels' ari values
	if (currPanel?.ari && nextPanel?.ari) {
		try {
			const currAri = AnyAri.parse(currPanel.ari);
			const nextAri = AnyAri.parse(nextPanel.ari);
			// ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
			return (
				`${currAri.resourceOwner}-${currAri.resourceType}` ===
				`${nextAri.resourceOwner}-${nextAri.resourceType}`
			);
		} catch (error) {
			// If parsing fails, we assume the ARI values do not match.
			return false;
		}
	}
	// If neither panel has a type or ari, we assume they do not match.
	return false;
};
